<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="close"
    @submit="confirm"
    class="addlinks-dialog"
  >
    <feishu-form
      ref="form"
      @submit="submitHandle"
    ></feishu-form>
  </sliderBarDialogShell>
</template>

<script>
import { buildFeishuConfigPayload, saveFeishuConfig } from '@/api/sys/robitConfig/feishu'
import feishuForm from '@/components/sys/robitCofig/feishu/feishuForm'

export default {
  name: 'addfeishu',
  components:{
    feishuForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      title: '新增飞书推送渠道'
    }
  },
  methods: {
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$refs.form.clearSignSecret();
      this.$emit('close');
    },

    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(formData){
      const request = saveFeishuConfig(buildFeishuConfigPayload(formData, false));
      this.$refs.form.clearSignSecret();
      request.then(() => {
        this.$refs.form.$refs.form.clearValidate();
        this.$refs.form.$refs.form.resetFields();

        this.$emit('add-success');
        this.$refs.form.reset();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addlinks-dialog {
  .el-select {
    width: 100%;
  }
}
</style>
